// extracted by mini-css-extract-plugin
export var divider = "_3v-0";
export var dividerText = "_3v-1";